export default __webpack_public_path__ + "static/media/icon_dnd.6dc46b2b.svg";